import React from 'react';

import logoLgSvg from '../brand/faves-logo-lg.svg';
import arrowUpRightIcon from '../brand/icon-arrow-up-right.svg';
import { useEmailSubscribe } from './useEmailSubscribe';
import './SiteFooter.css';

type SiteFooterProps = {
    csrfToken: string;
    redesignEnabled?: boolean
};

export function SiteFooter({ csrfToken, redesignEnabled = true }: SiteFooterProps) {
    const { email, submitting, error, success, onChange, onSubmit } = useEmailSubscribe(csrfToken);

    return (
        <footer className="site-footer">
            <div className="site-footer__container">
                <div className="site-footer__subscribe">
                    <div className="site-footer__subscribe-label">Subscribe for the latest updates.</div>
                    {success ? (
                        <div className="site-footer__subscribe-success">Thanks — we'll be in touch.</div>
                    ) : (
                        <form className="site-footer__subscribe-form" onSubmit={onSubmit} noValidate dir="ltr">
                            <input
                                type="email"
                                name="email"
                                autoComplete="email"
                                dir="ltr"
                                className="site-footer__subscribe-input"
                                placeholder="email"
                                aria-label="email"
                                value={email}
                                onChange={onChange}
                                disabled={submitting}
                            />
                            <button type="submit" className="site-footer__subscribe-submit" disabled={submitting}>
                                submit
                            </button>
                        </form>
                    )}
                    {error && (
                        <div className="site-footer__subscribe-error" role="alert">{error}</div>
                    )}
                </div>

                <div className="site-footer__link-groups">
                    { redesignEnabled && 
                        <>
                        <div className="site-footer__link-group">
                            <div className="site-footer__link-heading">explore</div>
                            <ul className="site-footer__link-list">
                                <li><a href="/roster" className="site-footer__link">roster</a></li>
                                <li><a href="/for-athletes" className="site-footer__link">for athletes</a></li>
                                <li><a href="/for-brands" className="site-footer__link">for brands</a></li>
                            </ul>
                        </div>
                        <div className="site-footer__link-group">
                            <div className="site-footer__link-heading">company</div>
                            <ul className="site-footer__link-list">
                                <li><a href="/careers" className="site-footer__link">careers</a></li>
                            </ul>
                        </div>
                        </>
                    }

                    <div className="site-footer__link-group">
                        <div className="site-footer__link-heading">social</div>
                        <ul className="site-footer__link-list">
                            <li>
                                <a
                                    href="https://www.instagram.com/faves.xyz/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="site-footer__link site-footer__link--social"
                                >
                                    <span>instagram</span>
                                    <img src={arrowUpRightIcon} alt="" className="site-footer__social-icon" />
                                </a>
                            </li>
                            <li>
                                <a
                                    href="https://x.com/favesxyz"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="site-footer__link site-footer__link--social"
                                >
                                    <span>x</span>
                                    <img src={arrowUpRightIcon} alt="" className="site-footer__social-icon" />
                                </a>
                            </li>
                            <li>
                                <a
                                    href="https://www.tiktok.com/@faves.xyz"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="site-footer__link site-footer__link--social"
                                >
                                    <span>tiktok</span>
                                    <img src={arrowUpRightIcon} alt="" className="site-footer__social-icon" />
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>

                <img src={logoLgSvg} alt="Faves" className="site-footer__wordmark" />

                <ul className="site-footer__legal-links">
                    <li><a href="/terms-of-service" className="site-footer__link site-footer__link--small">terms of service</a></li>
                    <li><a href="/privacy-policy" className="site-footer__link site-footer__link--small">privacy policy</a></li>
                    <li><a href="/affiliate-disclosure" className="site-footer__link site-footer__link--small">affiliate disclosure</a></li>
                </ul>
            </div>
        </footer>
    );
}
